import { logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { analytics } from './firebase';

export const EVENT_TYPE = {
  VIEW: 'View',
  CLICK: 'Click',
  COMPLETE: 'Complete',
};

export const EVENT_NAME = {
  view_dealer_home: 'view_dealer_home',
  dealer_home_click: 'dealer_home_click',
  dealer_login_complete: 'dealer_login_complete',
  view_dealer_signup_page1: 'view_dealer_signup_page1',
  view_dealer_signup_page2: 'view_dealer_signup_page2',
  view_dealer_signup_page3: 'view_dealer_signup_page3',
  dealer_signup_complete: 'dealer_signup_complete',
  bottomtab_click: 'bottomtab_click',
  view_customer_list: 'view_customer_list',
  dealer_home_top_click: 'dealer_home_top_click',
  customer_list_tab_click: 'customer_list_tab_click',
  customer_list_start_click: 'customer_list_start_click',
  view_consulting_dealer: 'view_consulting_dealer',
  consulting_dealer_click: 'consulting_dealer_click',
  consulting_dealer_price_click: 'consulting_dealer_price_click',
  consulting_dealer_complete: 'consulting_dealer_complete',
  consulting_dealer_complete_click: 'consulting_dealer_complete_click',
  consulting_customer_list_click: 'consulting_customer_list_click',
  view_consulting_customer_detail: 'view_consulting_customer_detail',
  consulting_customer_detail_click: 'consulting_customer_detail_click',
  consulting_customer_contact_click: 'consulting_customer_contact_click',
  consulting_customer_status_click: 'consulting_customer_status_click',
  release_customer_send_click: 'release_customer_send_click',
  release_customer_click: 'release_customer_click',
  dealer_search_click: 'dealer_search_click',
  dealer_search_result_click: 'dealer_search_result_click',
  view_company_release: 'view_company_release',
  company_release_car_click: 'company_release_car_click',
  company_release_region_click: 'company_release_region_click',
  company_release_buytype_click: 'company_release_buytype_click',
  company_release_time_click: 'company_release_time_click',
  company_release_deposit_click: 'company_release_deposit_click',
  company_release_age_click: 'company_release_age_click',
  company_release_distance_click: 'company_release_distance_click',
  company_release_income_click: 'company_release_income_click',
  company_release_complete: 'company_release_complete',
  view_dealer_mypage: 'view_dealer_mypage',
  dealer_mypage_release_click: 'dealer_mypage_release_click',
  dealer_mypage_click: 'dealer_mypage_click',
  view_dealer_membership: 'view_dealer_membership',
  dealer_membership_click: 'dealer_membership_click',
  deactivate_funnel1_click: 'deactivate_funnel1_click',
  deactivate_funnel2_click: 'deactivate_funnel2_click',
  activate_funnel_click: 'activate_funnel_click',
  view_dealer_myprofile: 'view_dealer_myprofile',
  dealer_myprofile_click: 'dealer_myprofile_click',
  dealer_myprofile_change_click: 'dealer_myprofile_change_click',
  view_dealer_referral: 'view_dealer_referral',
  dealer_referral_click: 'dealer_referral_click',
  view_dealer_purchase: 'view_dealer_purchase',
  dealer_purchase_click: 'dealer_purchase_click',
  dealer_purchase_add_click: 'dealer_purchase_add_click',
  dealer_purchase_add_complete: 'dealer_purchase_add_complete',
  dealer_purchase_confirm_click: 'dealer_purchase_confirm_click',
  cheer_up_click: 'cheer_up_click',
};

export const sendUserId = (userId: string) => {
  if (analytics) {
    setUserId(analytics, userId);
  }
};

export const sendUserProperties = (userProperties: Record<string, unknown>) => {
  if (analytics) {
    setUserProperties(analytics, userProperties);
  }
};

export const sendLogEvent = (
  eventName: string,
  eventType: string,
  eventParams?: Record<string, unknown>,
) => {
  if (analytics) {
    logEvent(analytics, eventName, { event: eventType, ...eventParams });
  }
};
